import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";

@Component({
	selector: "app-pick-list-by-home-room",
	templateUrl: "./pick-list-by-home-room.component.html",
	styleUrls: ["./pick-list-by-home-room.component.css"],
})
export class PickListByHomeRoomComponent implements OnInit {
	constructor(private selectService: SchoolselectorService, private reportService: ReportService, private dialogService: DialogService) {}

	report = {
		SchoolID: 0,
		SemesterID: 0,
		GroupByID: "Course",
	};

	lstSemester: any = [];

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	lstGroupBy = [
		{
			ID: "Course",
			Desc: "Course",
		},
		{
			ID: "CourseNo",
			Desc: "Course Number",
		},
		{
			ID: "Homeroom",
			Desc: "Homeroom",
		},
		{
			ID: "Instructor",
			Desc: "Instructor",
		},
		{
			ID: "Location",
			Desc: "Location",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 163;

	subscription: any;

	ngOnInit() {
		// this.AttendanceStatusList();
		// this.EntryTypeList();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;

		this.SemesterList();
	}

	private SemesterList() {
		this.report.SemesterID = 0;
		var result = this.reportService.SemesterGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.lstSemester = response;

				this.lstSemester.unshift({
					SemesterID: 0,
					Semester: "All Semesters",
				});

				this.report.SemesterID = this.lstSemester[0].SemesterID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		this.isProcessing = true;

		var strParam = this.GetStrParam();

		var reportID = 163;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);
		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		strParam += this.report.SemesterID + "|SemesterID";
		strParam += "," + this.report.GroupByID + "|GroupBy";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
